import { Component, Inject, ElementRef, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../../core/services/login.service';
import { isDevServer } from '../../../core/runtime-config';

interface MenuItem {
  label?: string;
  path?: string;
  requiredRoles?: string[];
  patrikOnly?: boolean;
  divider?: boolean;
}

@Component({
  selector: 'ng-kits-header-menu',
  template: require('./header-menu.component.html').default,
  standalone: false,
})
export class NgHeaderMenuComponent {
  isReportOpen = false;
  isSalesOpen = false;
  isAdminOpen = false;
  isKpiOpen = false;
  isUserOpen = false;
  readonly showPlayground = isDevServer();
  reportItems: MenuItem[] = [
    { label: 'Tid', path: 'reports' },
    { label: 'Frånvaro', path: 'absence' },
  ];
  salesItems: MenuItem[] = [
    { label: 'Sälj rap', path: 'salesReports', requiredRoles: ['admin', 'sälj'] },
    { label: 'Proj rap', path: 'projectReport', requiredRoles: ['admin', 'sälj'] },
    { label: 'Fastpris rap', path: 'fixedPriceProjects', requiredRoles: ['admin', 'sälj'] },
    { label: 'KPAO rap', path: 'projectSummaryReport', requiredRoles: ['admin', 'sälj'] },
  ];
  adminItems: MenuItem[] = [
    { label: 'Fakturera', path: 'invoice', requiredRoles: ['admin', 'sälj'] },
    { label: 'Lista skapade fakturor', path: 'invoiceReports', requiredRoles: ['admin', 'sälj'] },
    { label: 'Löneunderlag', path: 'salary', requiredRoles: ['admin'] },
    { label: 'Databas', path: 'admin', requiredRoles: ['admin'], patrikOnly: true },
  ];
  kpiItems: MenuItem[] = [
    { label: 'Tid/Timpris', path: 'timeStatisticsReport', requiredRoles: ['admin', 'styrelse'] },
  ];

  constructor(
    @Inject(LoginService) private login: LoginService,
    @Inject(Router) private router: Router,
    @Inject(ElementRef) private elementRef: ElementRef
  ) {}

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (
      this.elementRef &&
      this.elementRef.nativeElement &&
      !this.elementRef.nativeElement.contains(event.target)
    ) {
      this.closeAll();
    }
  }

  handleClick(path: string, event?: Event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.router.navigateByUrl('/' + path);
    this.closeAll();
  }

  toggleReport(event: Event) {
    event.stopPropagation();
    this.closeAll();
    this.isReportOpen = !this.isReportOpen;
  }

  toggleSales(event: Event) {
    event.stopPropagation();
    this.closeAll();
    this.isSalesOpen = !this.isSalesOpen;
  }

  toggleAdmin(event: Event) {
    event.stopPropagation();
    this.closeAll();
    this.isAdminOpen = !this.isAdminOpen;
  }

  toggleKpi(event: Event) {
    event.stopPropagation();
    this.closeAll();
    this.isKpiOpen = !this.isKpiOpen;
  }

  toggleUser(event: Event) {
    event.stopPropagation();
    this.closeAll();
    this.isUserOpen = !this.isUserOpen;
  }

  closeAll() {
    this.isReportOpen = false;
    this.isSalesOpen = false;
    this.isAdminOpen = false;
    this.isKpiOpen = false;
    this.isUserOpen = false;
  }

  harNagonRoll(requiredRoles?: string[]) {
    return this.login.harNagonRoll(requiredRoles || []);
  }

  arPatrik() {
    return this.login.arPatrik();
  }

  isMenuItemVisible(item: MenuItem) {
    return this.harNagonRoll(item.requiredRoles) && (!item.patrikOnly || this.arPatrik());
  }

  harSynligaPoster(items: MenuItem[]) {
    return items.some((item) => item.divider || this.isMenuItemVisible(item));
  }

  getUserName() {
    const user = this.login.getUser();
    return user ? user.slack : '';
  }
}
